import type { Plan } from '../../types/plans';
import type { Customer, CustomerConsent, CustomFormField, LoginChallenge } from '../../types/account';
import type { Offer } from '../../types/checkout';
import type { PaymentDetail, Subscription, Transaction } from '../../types/subscription';

import { createStore } from './utils';

export type ChallengeState = { id: string; challenge: LoginChallenge; data: Record<string, string> };

type AccountStore = {
  loading: boolean;
  user: Customer | null;
  subscription: Subscription | null;
  transactions: Transaction[] | null;
  entitledPlan: Plan | null;
  activePayment: PaymentDetail | null;
  customerConsents: CustomerConsent[] | null;
  publisherConsents: CustomFormField[] | null;
  publisherConsentsLoading: boolean;
  pendingOffer: Offer | null;
  challenge: Record<string, ChallengeState>;
  addChallenge: (challenge: LoginChallenge, data?: Record<string, string>) => ChallengeState;
  getChallenge: (id: string) => ChallengeState | undefined;
  setLoading: (loading: boolean) => void;
  getAccountInfo: () => { customerId: string; customer: Customer; customerConsents: CustomerConsent[] | null };
};

export const useAccountStore = createStore<AccountStore>('AccountStore', (set, get) => ({
  loading: false,
  user: null,
  subscription: null,
  transactions: null,
  entitledPlan: null,
  activePayment: null,
  customerConsents: null,
  publisherConsents: null,
  publisherConsentsLoading: false,
  pendingOffer: null,
  challenge: {},
  addChallenge: (challenge: LoginChallenge, data: Record<string, string> = {}) => {
    const id = Date.now().toString(36) + Math.random().toString(36).slice(2);
    const state = { id, challenge, data };
    set({ challenge: { ...get().challenge, [id]: state } });
    return state;
  },
  getChallenge: (id: string) => get().challenge[id],
  setLoading: (loading: boolean) => set({ loading }),
  getAccountInfo: () => {
    const user = get().user;
    const customerConsents = get().customerConsents;

    if (!user?.id) throw new Error('user not logged in');

    return { customerId: user?.id, customer: user, customerConsents };
  },
}));
